<template>
  <div>
    <PageHeader title="User Master" class="list">
      <template #title-header-content>
        <div class="flex-1 pl-2 flex ml-6 justify-end items-center">

          <Icon 
            iconName="Refresh" 
            :clickable="false" 
            :class="{'animate-spin': loading}" 
            class="text-white hover:text-gray-300 active:text-gray-400 ml-4 cursor-pointer"
            @click.native="refresh"
          />
        </div>
      </template>
      <template #page-header-content>
        <div class="pl-4 flex items-center">
          <h1 class="text-lg font-bold text-white flex items-center">            
            <Icon iconName="UserGroup" class="w-7 h-7 mr-2" /> <span class="mt-0">ユーザー 一覧</span>
          </h1>
          
          <!-- 新規登録ボタン 権限のある人のみ表示 -->
          <div class="flex-1 pl-2 flex ml-6 justify-end items-center">
            <div>
              <PrimaryButton text="新規" size="normal hover:bg-pink-400" class="new" @click="edit({})"/>
            </div>
          </div>
        </div>
      </template>
    </PageHeader>

    
    <main class="absolute top-32 w-screen bottom-4 -mt-2 leading-8 row">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">
          <table class="table text-sm">
            <thead class="th sticky top-0 z-20">
              <tr class="column text-xs">
                <th class="th2 col1 th-lock">表示順</th>
                <th class="th2 col2 th-lock">社員No.</th>
                <th class="th2 text-left col3 th-lock">名前/メールアドレス</th>
                <th class="th1 col4 th-lock"></th>
                <th class="th2 text-left">部署</th>
                <th class="th2 text-left min-w-min">兼任部署</th>
                <!-- 社員の名札（役職・ローマ字・顔写真はモーダルで登録。ここは見るだけ） -->
                <th class="th2 text-left" v-tooltip="'社員の名札。役職・ローマ字・顔写真は「名札作成」で登録'">名札</th>
                <!-- 権限 -->
                <th class="th2" v-tooltip="'マスタメンテ編集可能、ログ一覧閲覧可能'">管理者<br> 権限</th>
                <th class="th2" v-tooltip="'ユーザー設定可能'">ユーザー<br> 権限</th>
                <th class="th2" v-tooltip="'見積りの承認者になる'">見積承認<br> 権限</th>
                <th class="th2" v-tooltip="'メインタスク登録可能'">メインタスク<br> 権限</th>
                <th class="th2" v-tooltip="'サブタスク登録・削除可能'">サブタスク<br> 権限</th>
                <th class="th2" v-tooltip="'見積り登録・削除可能'">見積<br> 権限</th>
                <th class="th2" v-tooltip="'品質巡回担当者・閲覧・登録'">品質巡回<br> 権限</th>
                <th class="th2" v-tooltip="'巡回清掃担当者・閲覧・登録'">巡回清掃<br> 権限</th>
                <th class="th2" v-tooltip="'定期清掃担当者・閲覧・登録'">定期清掃<br> 権限</th>
                <th class="th2" v-tooltip="'設備点検担当者・閲覧・登録'">設備点検<br> 権限</th>
                <th class="th2" v-tooltip="'閲覧・登録'">写真報告<br> 権限</th>
                <th class="th2" v-tooltip="'採否未決、不採用の社員面接データを閲覧・登録'">社員面接<br> 権限</th>
                <th class="th2" v-tooltip="'閲覧・登録'">評価シート<br> 権限</th>
                <th class="th2" v-tooltip="'閲覧・登録'">賞与設定<br> 権限</th>
                <th class="th2" v-tooltip="'閲覧・登録'">契約情報<br> 権限</th>
                <th class="th2" v-tooltip="'予定・閲覧・登録'">RLS<br> 権限</th>
                <th class="th2" v-tooltip="'クオリティレポート（物件設定・予定・結果）を見られる'">ｸｵﾘﾃｨ<br> ﾚﾎﾟｰﾄ</th>
                <th class="th2" v-tooltip="'AKBS関連メニュー（申請一覧・登録済み一覧・出力・賃金）を見られる'">AKBS<br> メニュー</th>
                <th class="th2" v-tooltip="'雇用指示の申請の承認・AKBSへ登録、登録済み清掃員の編集'">雇用指示<br> 権限</th>
                <th class="th2" v-tooltip="'契約詳細の申請の承認・AKBSへ登録'">契約詳細<br> 権限</th>
                <th class="th2">デンタツ</th>
                <th class="th2">上司</th>
                <th class="th2">パート</th>
                <th class="th2 text-left">課・エリア</th>
                <th class="th1"></th>
              </tr>
            </thead>
            <tbody v-for="(row, index) in list" :key="index">
              <tr :class="setColor(index)" class="hover-color">
                <!-- 表示順 -->
                <td class="td2 text-right pr-5 col1">{{row.sortNo!='null' ? row.sortNo : ''}}</td>
                <!-- ID -->
                <td class="td2 text-gray-400 font-bold col2">{{row.userNum}}</td>
                <!-- 名前 -->
                <td class="td2 col3">
                  <pre>{{row.userName}}</pre>
                  <pre class="text-indigo-500">{{row.eMailAdress}}</pre>
                  <pre v-if="row.eMailAdressTask" class="text-gray-600 my-1">（{{ row.eMailAdressTask }}）</pre>
                  <pre v-if="row.holidays==3" class="text-green-700 text-xs">（週休{{row.holidays}}日）</pre>
                  <pre v-if="row.fullTime!=8" class="text-green-700 text-xs">（時短{{row.fullTime}}ｈ）</pre>
                  <pre v-if="row.holidayWeeks&&row.holidayWeeks.length" class="text-green-700 text-xs">{{ getWeek(row.holidayWeeks) }}</pre>
                  <pre v-if="row.workEndDate" class="text-red-700 text-xs font-bold">最終勤務日 ：{{ row.workEndDate }}</pre>
                  <pre v-if="row.resignationDate" class="text-red-700 text-xs font-bold">退職日 ：{{ row.resignationDate }}</pre>
                </td>
                <td class="td1 col4"><PrimaryButton text="編集" class="w-max" @click="edit(row)" /></td>
                <!-- 部署 -->
                <td class="td2 text-xs"><pre>{{row.departmentName}}</pre></td>
                <!-- 兼任部署 -->
                <td class="td2 text-xs"><pre>{{row.dualDepartmentName.join('\r\n')}}</pre></td>
                <!-- 社員の名札：役職・ローマ字・顔写真の有無と、名札のモーダルを開くボタン -->
                <td class="td2 text-xs">
                  <div class="flex items-center gap-2 whitespace-nowrap">
                    <div class="leading-5">
                      <div>役職：{{ row.userPost || '－' }}</div>
                      <div>ローマ字：{{ row.userRomaji || '－' }}</div>
                      <div>顔写真：<span :class="row.hasNameplatePhoto ? 'text-green-700 font-bold' : 'text-gray-500'">{{ row.hasNameplatePhoto ? 'あり' : 'なし' }}</span></div>
                    </div>
                    <PrimaryButton text="名札作成" size="sm" class="w-max" @click="openNameplate(row)" />
                  </div>
                </td>
                <!-- 管理者権限 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.adminAuth"
                    />
                  </th>
                </td>
                <!-- ユーザー管理 -->
                <td class="td2 cursor-not-allowed">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.userAuth"
                    />
                  </th>
                </td>
                <!-- 承認 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.estimateApproveAuth"
                    />
                  </th>
                </td>
                <!-- メイン -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.mainAuth"
                    />
                  </th>
                </td>
                <!-- サブ -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.subAuth"
                    />
                  </th>
                </td>
                <!-- 見積り -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.estimateAuth"
                    />
                  </th>
                </td>
                <!-- 品質巡回 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.patrolAuth"
                    />
                  </th>
                </td>
                <!-- 巡回清掃 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.roundCleanAuth"
                    />
                  </th>
                </td>
                <!-- 定期清掃 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.fixedCleanAuth"
                    />
                  </th>
                </td>
                <!-- 設備点検 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.facilityPatrolAuth"
                    />
                  </th>
                </td>
                <!-- 写真報告 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.photoReportAuth"
                    />
                  </th>
                </td>
                
                <!-- 社員面接 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.regularStaffAuth"
                    />
                  </th>
                </td>
                <!-- 評価シート -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.evaluationAuth"
                    />
                  </th>
                </td>
                <!-- 賞与 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.bonusAuth"
                    />
                  </th>
                </td>
                <!-- 契約情報 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.contractAuth"
                    />
                  </th>
                </td>
                <!-- RLS -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded" 
                      :disabled="true"
                      v-model="row.rlsAuth"
                    />
                  </th>
                </td>
                <!-- クオリティレポート -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input
                      type="checkbox"
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded"
                      :disabled="true"
                      v-model="row.qualityReportAuth"
                    />
                  </th>
                </td>
                <!-- AKBS関連メニュー -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input
                      type="checkbox"
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded"
                      :disabled="true"
                      v-model="row.akbsMenuAuth"
                    />
                  </th>
                </td>
                <!-- AKBS -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input
                      type="checkbox"
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded"
                      :disabled="true"
                      v-model="row.akbsAuth"
                    />
                  </th>
                </td>
                <!-- 契約詳細 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input
                      type="checkbox"
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded"
                      :disabled="true"
                      v-model="row.contractDetailAuth"
                    />
                  </th>
                </td>
                <!-- デンタツ -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded green-check" 
                      :disabled="true"
                      v-model="row.transmission"
                    />
                  </th>
                </td>
                <!-- 上司 -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded green-check" 
                      :disabled="true"
                      v-model="row.boss"
                    />
                  </th>
                </td>
                <!-- パート -->
                <td class="td2 cursor-not-allowed'">
                  <th scope="col" class="cursor-not-allowed px-6 py-3 text-sm font-medium text-gray-500 uppercase tracking-wider w-20 text-center sticky top-0 z-10">
                    <input 
                      type="checkbox" 
                      class="cursor-not-allowed h-4 w-4 border-gray-400 rounded green-check" 
                      :disabled="true"
                      v-model="row.partTimer"
                    />
                  </th>
                </td>
                <!-- 課 -->
                <td class="td2 text-xs"><pre>{{row.departmentSubName}}</pre></td>
                
                <td class="td1 p-1"><PrimaryButton text="退職" class="w-max" @click="deleteData(row)" size="normal bg-red-500 text-white hover:bg-red-600 mx-1"/></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>

    <!-- 編集・新規登録モーダル -->
    <UserMasterModal 
      v-model="modalShow"
      :target="editData"
      :open="openModal"
      :bossList="bossList"
      :areaList="areaList"
      :userList="list"
      :departmentList="departmentList"
      :allDepartmentSubList="allDepartmentSubList"
      @modalClose="modalClose"
    />

    <!-- 社員の名札（役職・ローマ字・顔写真の登録と PDF） -->
    <EmployeeNameplateModal
      v-model="nameplateShow"
      :open="nameplateOpen"
      :userId="nameplateUserId"
      @saved="getData"
    />
  </div>
</template>

<script>
import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import UserMasterModal from '../components/UserMasterModal.vue'
import EmployeeNameplateModal from '../components/EmployeeNameplateModal.vue'
import * as utils from '@libs/utils'
import { WEEK_NUM } from '@libs/constants'
import * as backend from '@libs/backend'
import * as dialogs from '@libs/dialogs'
import * as logManager from '@managers/logManager'
import PageModel from '../../main/pages/PageModel.vue'
import * as moment from 'moment'
import * as requestPostManager from '@managers/requestPostManager'

export default {
  extends: PageModel,
  components: {
    Icon,
    PageHeader,
    PrimaryButton,
    UserMasterModal,
    EmployeeNameplateModal
  },

  data() {
    return {
      loading: false,
      initial: true,
      freeze: true,
      // モーダル表示
      modalShow: false,
      // 編集する内容
      editData: {},
      openModal: 0,
      // 社員の名札のモーダル
      nameplateShow: false,
      nameplateOpen: 0,
      nameplateUserId: null,
      // 編集権限
      auth: false,
      // データ
      list: [],
      // 上司リスト
      bossList: [],
      // 巡回担当エリア
      areaList: [],
      // 部署リスト
      departmentList: [],
      // 課リスト
      allDepartmentSubList: []
    }
  },

  async created() {
    this.freeze = true
    if (this.$store.getters.auth && this.$store.getters.auth.userAuth) {
      this.auth = true
    }
    let res = await backend.searchData('user/userSetting')
    if (res.data) {
      this.bossList = res.data.bossList
      this.areaList = res.data.areaList
    }
    
    await this.getData()
  },

  mounted() {
    this.$nextTick(() => {
      this.freeze = false
      this.refresh()
    })
  },

  computed: {
    getWeek() {
      return (tar) => {
        const res = []
        for (let i = 0; i < WEEK_NUM.length; i++) {
          const w = WEEK_NUM[i]
          if (tar.includes(w.value)) {
            res.push(w.text)
          }
        }
        return ` ※${res.join('・')}曜日は休み`
      }
    }
  },

  methods: {

    async refresh() {
      this.loading = true
      await this.getData()
      this.loading = false
    },

    /**
     * データ取得
     */
    async getData() {
      let res = await backend.searchData('user/getUserList', { day: utils.getToday() })
      this.list = res.data.data
      let res1 = await backend.getData('department/get')
      this.departmentList = res1.data.data
      let res2 = await backend.getData('departmentSub/get')
      this.allDepartmentSubList = res2.data.data
    },

    /**
     * 背景色設定
     */
    setColor(i) {
      if (i % 2 != 0) {
        return 'bg-blue'
      } else {
        return 'bg-none'
      }
    },

    /**
     * 編集イベント
     * @param data 編集内容
     */
    edit(data) {
      this.openModal++
      this.modalShow = true
      this.editData = data
    },

    /**
     * 社員の名札のモーダルを開く（その行の人で）
     * @param row ユーザー
     */
    openNameplate(row) {
      this.nameplateUserId = row.id
      this.nameplateOpen++
      this.nameplateShow = true
    },

    /**
     * モーダルを閉じる
     */
    async modalClose() {
      this.modalShow = false
      await this.getData()
    },

    /**
     * 削除ボタン イベント
     * @param row 対象データ
     */
    async deleteData(row) {
      const deleteConf = await dialogs.showWarningConfirmDialog('削除', '削除してよろしいですか？\r\n退職でない限り、ユーザーを削除するのは好ましくありません。\r\n変更箇所がある場合は、削除ではなく編集してください。\r\nまた、同行予定やその他ユーザーIDが紐づくデータが削除されることがあります。')
      if (deleteConf != 'YES') {
        return false
      }
      let du = this.$store.getters.user.id
      // mst_user論理削除
      const res = await backend.deleteFlag('user/deleteFlag', { updateUser: du, id: row.id })

      if (res.data.data.length) {
        // 未完了の同行予定が削除された場合、メインタスクも削除
        let msg = []
        for (let i = 0; i < res.data.data.length; i++) {
          const e = res.data.data[i]
          await requestPostManager.deleteAccompanyTask(this, { id: e.id })
          msg.push(e.insert_user_name + 'の' + moment(e.scheduled_date).format('YYYY/MM/DD'))
        }
        logManager.recording(this, logManager.Loglevel.INFO, '同行予定', '削除', 'ユーザー（ID：' + row.id + '）削除のため、\r\n' + msg.join('、\r\n') + 'の同行予定を削除しました。')
      }
      logManager.recording(this, logManager.Loglevel.INFO, 'ユーザー設定', '削除', 'ユーザー（ID：' + row.id + '、 ユーザー名：' + row.userName + '）を削除しました。')
      this.getData()
    }

  }
}
</script>

<style scoped>
.table {
  width: 100%;
}

.column th {
  height: 50px;
  background: #edecf7;
}

.bg-blue {
  background: rgb(243 247 249);
}

.th1 {
  width: 100px;
  text-align: center;
}

.th2 {
  /* text-align: left; */
  padding-left: 10px;
}

.td1 {
  text-align: center;
}

.td2 {
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.th-lock{
  z-index: 12 !important;
}

.bg-blue .col1,
.bg-blue .col2,
.bg-blue .col3,
.bg-blue .col4{
  background: rgb(243 247 249);
}

.bg-none .col1,
.bg-none .col2,
.bg-none .col3,
.bg-none .col4{
  background: white;
}

.hover-color:hover .col1,
.hover-color:hover .col2,
.hover-color:hover .col3,
.hover-color:hover .col4{
  background: rgba(184, 244, 242);
}

.col1{
  position: sticky;
  left: 0;
  z-index: 11;
}

.col2{
  position: sticky;
  left: 60px;
  z-index: 11;
}

.col3{
  position: sticky;
  left: 103px;
  z-index: 11 !important;
}

.col4{
  position: sticky;
  left: 406px;
  z-index: 11;
}

.new {
  width: 200px;
  background: #eb94c8;
}

.w-fit {
  width: fit-content;
}

.hover-color:hover {
  background: rgba(184, 244, 242, 0.67);
}

.green-check {
  color: rgb(39, 152, 39);
}

@media screen and (max-width: 1000px) {
  .list {
    min-width: 1000px !important;
  }
}
</style>